import { Component, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ConnectDevice } from "../../../_objects/connect-device";
import { OfflineUtilsService } from "../../../_offline/services/offline-utils.service";
import { CommonSnackBarService } from "../../../_services/common-snack-bar.service";
import { ConnectDeviceDbService } from "../../../_services/database/connect-device-db.service";
import { SpinnerService } from "../../../_services/spinner.service";

@Component({
  selector: "app-device-connect-dialog",
  templateUrl: "./device-connect-dialog.component.html",
  styleUrls: ["./device-connect-dialog.component.scss"],
  standalone: false
})
export class DeviceConnectDialogComponent {
  public pinCodeForm = new FormControl<string>(null);
  public isIplexOne: boolean;

  constructor(
    public oscSpinnerService: SpinnerService,
    public offlineUtilsService: OfflineUtilsService,
    public snackBar: CommonSnackBarService,
    public translate: TranslateService,
    public connectDeviceDbService: ConnectDeviceDbService,
    @Inject(MAT_DIALOG_DATA) public data: { isIplexOne: boolean }
  ) {
    this.isIplexOne = data.isIplexOne;
  }

  // https://ossa-cloud.visualstudio.com/OSD%20Visol%20Solution/_sprints/backlog/OSD%20ViSOL%20for%20Brian%20Team/OSD%20Visol%20Solution/OSD%20ViSOL%20for%20Brian%20Iterations/FY24%20Third%20Quarter?workitem=29568
  public async connectDevice() {
    // ToDo PIN Codeを送信して、トークンを受け取る為の処理を追加
    const device = new ConnectDevice();
    device.id = "id-000001";
    device.connectedBy = "connectedBy-000001";
    device.isDeleted = false;
    device.isValid = true;
    device.model = "model-000001";
    device.serialNo = "serial-000001";
    device.token = "token-000001";

    this.saveConnectDevice(device);
  }

  // ToDo ボタンを配置する場所が決まり次第修正
  // https://ossa-cloud.visualstudio.com/OSD%20Visol%20Solution/_sprints/backlog/OSD%20ViSOL%20for%20Brian%20Team/OSD%20Visol%20Solution/OSD%20ViSOL%20for%20Brian%20Iterations/FY24%20Second%20Quarter?workitem=29571
  // https://ossa-cloud.visualstudio.com/OSD%20Visol%20Solution/_sprints/backlog/OSD%20ViSOL%20for%20Brian%20Team/OSD%20Visol%20Solution/OSD%20ViSOL%20for%20Brian%20Iterations/FY24%20Second%20Quarter?workitem=29570
  // https://ossa-cloud.visualstudio.com/OSD%20Visol%20Solution/_sprints/backlog/OSD%20ViSOL%20for%20Brian%20Team/OSD%20Visol%20Solution/OSD%20ViSOL%20for%20Brian%20Iterations/FY24%20Third%20Quarter?workitem=29568

  async saveConnectDevice(device: ConnectDevice) {
    this.oscSpinnerService.show(true);
    await this.connectDeviceDbService.put(device).toPromise();

    if (this.isIplexOne) {
      this.offlineUtilsService.startAppExe(true, device.token).subscribe(
        (_) => this.oscSpinnerService.hide(true),
        (error) => {
          console.log(error);
          this.oscSpinnerService.hide(true);
          this.snackBar.open(this.translate.instant("device-connect-dialog.launchAppFailed"));
        }
      );
    } else {
      this.oscSpinnerService.hide(true);
    }
  }
}
